import { TrashCalendarApiTrashCalendarCreateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTrashCalendarCreateMutation = () =>
  useBaseMutation({
    mutationFn: (req: TrashCalendarApiTrashCalendarCreateRequest, config) =>
      appApiClient.trashCalendarApi.trashCalendarCreate(req, config),
  });
